module.exports = __webpack_public_path__ + "img/msg02.b902937a.png";